import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var blue = {
  10: "#1a66ff",
  20: "#004ae0",
  30: "#003db8",
  40: "#d1e0ff",
  50: "#eff4ff"
};
var red = {
  10: "#eb1700",
  20: "#c71705",
  30: "#ac180A",
  40: "#fbd1cc"
};
var green = {
  10: "#00b67a",
  20: "#059c6b",
  30: "#08875f",
  40: "#ccf0e4"
};
var yellow = {
  10: "#ffaf05",
  40: "#ffefcd"
};
var gray = {
  10: "#1b1b21",
  20: "#454554",
  30: "#6f6f87",
  40: "#9a9aad",
  50: "#c5c5d6",
  60: "#dcdce6",
  70: "#f2f2f5",
  80: "#f9f9fa"
};
var starRating = {
  5: "#00b67a",
  4: "#73CF11",
  3: "#ffce00",
  2: "#ff8622",
  1: "#ff3722",
  0: "#dcdce6"
};

/**
 * A combination of these colors can be used for charts with multiple data sources.*
 */
var chart = {
  blue: {
    40: "#112C99",
    30: "#4D6EC6",
    20: "#C8DAF7",
    10: "#EEF2FB"
  },
  orange: {
    40: "#FF7116",
    30: "#F7AD53",
    20: "#FFE8B6",
    10: "#FFF6E0"
  },
  purple: {
    40: "#4E1298",
    30: "#A772EA",
    20: "#CCC8FA",
    10: "#EFEBFC"
  },
  teal: {
    40: "#006472",
    30: "#2FCBCC",
    20: "#A4EAEA",
    10: "#DFFAFA"
  }
};
export var colors = {
  blue: _objectSpread(_objectSpread({}, blue), {}, {
    hero: blue[10],
    functional: blue[10],
    hover: blue[20],
    active: blue[30],
    focusOutline: blue[40],
    highlight: blue[50]
  }),
  red: _objectSpread(_objectSpread({}, red), {}, {
    hover: red[20],
    active: red[30],
    focusOutline: red[40]
  }),
  green: _objectSpread(_objectSpread({}, green), {}, {
    upgrade: green[10],
    hover: green[20],
    active: green[30],
    focusOutline: green[40]
  }),
  yellow: yellow,
  gray: _objectSpread(_objectSpread({}, gray), {}, {
    inkHeadings: gray[10],
    inkBody: gray[20],
    inkSubdued: gray[30],
    buttonBorders: gray[50],
    cardBorder: gray[60],
    bodyBackground: gray[70],
    lightBackground: gray[80]
  }),
  starRating: starRating,
  white: "#ffffff",
  chart: _objectSpread(_objectSpread({}, chart), {}, {
    /**
     * Used for all charts with a single data source.
     */
    hero: chart.blue[30],
    /**
     * Colors used to express a positive, negative or neutral change.
     */
    sentiment: {
      positive: green[10],
      negative: red[10],
      neutral: gray[30]
    },
    /**
     * Colors for specific review sources in Line charts
     */
    reviewSources: {
      organic: chart.teal[30],
      automated: chart.orange[30],
      manual: chart.purple[30],
      redirected: chart.blue[30]
    }
  })
};